export default "__VITE_ASSET__BVI9tKG5__"